export default "__VITE_ASSET__DnAkdoHr__"